import {DomainObject} from 'shared/store';
import { observable, action, computed, makeObservable } from 'mobx';
import {Employee} from 'main/stores/employees';
import {User} from 'main/stores/users';
import _ from 'lodash';

class TimeTrackingSchedule extends DomainObject {
  id;
  name;
  configuredAt;
  sendSchedulePublishedNotification;

  managers = [];
  employees = [];

  _relations = {
    managers: [User],
    employees: [Employee]
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      name: observable,
      configuredAt: observable,
      sendSchedulePublishedNotification: observable,
      managers: observable,
      employees: observable,
      addManager: action,
      removeManager: action,
      setEmployees: action,
      configured: computed,
      sortedEmployees: computed
    });

    this.merge(other);
  }

  addManager(user) {
    this.managers.push(user);
  }

  removeManager(user) {
    this.managers = _.reject(this.managers, {id: user.id});
  }

  setEmployees(employees) {
    this.employees.replace(employees);
  }

  get configured() {
    return !!this.configuredAt;
  }

  get sortedEmployees() {
    return _.sortBy(this.employees, 'name');
  }
}

export default TimeTrackingSchedule;
